import React, { useState, useEffect } from "react";
import "./RegisterForm.css";
import Logo from "../../assets/images/logo/logo1.svg";
import { ToastContainer } from "react-toastify";
import { showToast } from "../utils/Function/Helper";
import { addSuperadmin } from "../../services/api/api";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../redux/slice/user";
import { Link } from "react-router-dom";

import { Password } from "primereact/password";

const RegisterForm = () => {

  const dispatch = useDispatch();

  useEffect(() => {


    console.log("working");
    
    localStorage.removeItem("sessionId");
    dispatch(setUserDetails({ loggedin: "no", userDetails: {} }));
  }, []);  


  const [formValues, setFormValues] = useState({
    superadmin_name: "",
    superadmin_email: "",
    superadmin_password: "",
    superadmin_password_re: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);      
      try {
        const response = await addSuperadmin(formValues);

        console.log(response);
        
        if (response.status) {
          showToast("success", `${response.message}`);
      
          setTimeout(() => {
              window.location.href = "/login";
          }, 2000); //2000ms = 2 seconds
      } else {
          showToast("error", `${response.message}`);
        }
      } catch (error) {
        showToast("error", `Login Failed ${error.message}`);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChange = (e, type) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear error on input change
  };

  const validate = () => {
    const newErrors = {};


    if (!formValues.superadmin_name) {
      newErrors.superadmin_name = "Name is required";
    } 

    // Email validation
    if (!formValues.superadmin_email) {
      newErrors.superadmin_email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formValues.superadmin_email)) {
      newErrors.superadmin_email = "Please enter a valid email";
    }

    // Password validation
    if (!formValues.superadmin_password) {
      newErrors.superadmin_password = "Password is required";
    }else if(!formValues.superadmin_password_re){
      newErrors.superadmin_password_re = "Enter Password again !";
    }else{
      if(formValues.superadmin_password !== formValues.superadmin_password_re){
        newErrors.superadmin_password_re = "Password not matching !";

      }
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };



  return (
    <>
      <div>
        <ToastContainer />
        <div className="container-fluid d-flex justify-content-center align-items-center login-container">
          <div className="card my-5 login-wrapper bg-light">
            <form
              className="card-body cardbody-color p-lg-5 bg-glass"
              onSubmit={handleSubmit}
            >
              <div className="text-center">
                <img
                  src={Logo}
                  className="img-fluid profile-image-pic img-thumbnail rounded-circle mb-5"
                  width="200px"
                  alt="profile"
                />
              </div>

              <div className="mb-3">
                <input
                  name="superadmin_name"
                  type="text"
                  className={
                    errors.superadmin_name
                      ? "form-control border border-danger"
                      : "form-control"
                  }
                  id="superadmin_name"
                  placeholder="Name"
                  value={formValues.superadmin_name}
                  onChange={(e)=>handleChange(e, 'superadmin_name')}
                  autoComplete="new-username"
                />
                {errors.superadmin_name && (
                  <span style={{ color: "red" }}>{errors.superadmin_name}</span>
                )}
              </div>


              <div className="mb-3">
                <input
                  name="superadmin_email"
                  type="text"
                  className={
                    errors.superadmin_email
                      ? "form-control border border-danger"
                      : "form-control"
                  }
                  id="superadmin_email"
                  placeholder="Email"
                  value={formValues.superadmin_email}
                  onChange={(e)=>handleChange(e, 'superadmin_email')}
                  autoComplete="new-username"
                />
                {errors.superadmin_email && (
                  <span style={{ color: "red" }}>{errors.superadmin_email}</span>
                )}
              </div>
              <div className="mb-3">

              <Password
                name="superadmin_password"
                className={
                  errors.superadmin_password
                    ? "form-password border border-danger"
                    : "form-password"
                }
                id="superadmin_password"
                placeholder="Password"
                feedback={false}
                value={formValues.superadmin_password}
                onChange={handleChange}
                toggleMask
              />
              {errors.superadmin_password && (
                <span style={{ color: "red" }}>{errors.superadmin_password}</span>
              )}
              </div>


<Password
                name="superadmin_password_re"
                className={
                  errors.superadmin_password_re
                    ? "form-password border border-danger"
                    : "form-password"
                }
                id="superadmin_password_re"
                placeholder="Re Enter Password"
                feedback={false}
                value={formValues.superadmin_password_re}
                onChange={handleChange}
                toggleMask
              />
              {errors.superadmin_password_re && (
                <span style={{ color: "red" }}>{errors.superadmin_password_re}</span>
              )}

              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-color px-5 mt-4 mb-5 w-100"
                  disabled={loading}
                >
                  {" "}
                  {loading ? "Loading..." : "Register"}
                </button>
              </div>

    <Link className="forgot-pass-text" to="/login" >Back to Login</Link>

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterForm;
